import PropTypes from 'prop-types';
import GroupIcon from '@material-ui/icons/Group';
import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import UsersManager from './UsersManager';
import SystemStatistics from './SystemStatistics';
import SystemControl from './SystemControl';
import PageLayout from '../PageLayout';
import InsertChartIcon from '@material-ui/icons/InsertChartOutlined';
import SettingsApplicationsIcon from '@material-ui/icons/SettingsApplicationsOutlined';

const baseURL = "/administration";

class AdministrationManager extends Component {

  render() {

    const { user } = this.props;

    let options = [
      {
        name: "System Statistics",
        url: 'systemstatistics',
        icon: <InsertChartIcon />
      },
      {
        name: "User Management",
        url: 'usermanagement',
        icon: <GroupIcon />
      }
    ];

    if (user.systemAdmin) {
      options.push({
        name: "System Control",
        url: 'systemcontrol',
        icon: <SettingsApplicationsIcon />
      });
    }

    const pageCrumb = <Switch>
      <Route path={baseURL + "/systemstatistics"} render={() => <span>System Statistics</span>} />
      {user.systemAdmin && <Route path={baseURL + "/systemcontrol"} render={() => <span>System Control</span>} />}
      <Route path={baseURL + "/usermanagement"} render={() => <span>User Management</span>} />
    </Switch>;

    return (
      <PageLayout
        title="Administration"
        baseURL="/administration"
        options={options}
        layoutTitle={function () { return (pageCrumb); }}
        breadcrumb={{
          baseURL,
          title: "Administration",
          static: pageCrumb
        }}>
        <Switch>
          <Route path={baseURL + "/systemstatistics"} render={(props) => <SystemStatistics {...props} {...this.props} />} />
          {user.systemAdmin && <Route path={baseURL + "/systemcontrol"} render={(props) => <SystemControl {...props} {...this.props} />} />}
          <Route path={baseURL + "/usermanagement"} render={(props) => <UsersManager {...props} {...this.props} />} />
        </Switch>
      </PageLayout>
    );
  }
}

AdministrationManager.propTypes = {
  user: PropTypes.object
};

export default AdministrationManager;